var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentsManagement(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "local_atm"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9_7424",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 30,
    height: 30,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9_7424)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "local_atm_2",
    d: "M14.5625 20.4375H15.4375V19.1875H17.0625C17.3125 19.1875 17.5208 19.1042 17.6875 18.9375C17.8542 18.7708 17.9375 18.5625 17.9375 18.3125V15.4375C17.9375 15.1875 17.8542 14.9792 17.6875 14.8125C17.5208 14.6458 17.3125 14.5625 17.0625 14.5625H12.9375V11.6875H17.9375V10.8125H15.4375V9.5625H14.5625V10.8125H12.9375C12.6875 10.8125 12.4792 10.8958 12.3125 11.0625C12.1458 11.2292 12.0625 11.4375 12.0625 11.6875V14.5625C12.0625 14.8125 12.1458 15.0208 12.3125 15.1875C12.4792 15.3542 12.6875 15.4375 12.9375 15.4375H17.0625V18.3125H12.0625V19.1875H14.5625V20.4375ZM6 23.375C5.45833 23.375 5.01042 23.1979 4.65625 22.8438C4.30208 22.4896 4.125 22.0417 4.125 21.5V8.5C4.125 7.95833 4.30208 7.51042 4.65625 7.15625C5.01042 6.80208 5.45833 6.625 6 6.625H24C24.5417 6.625 24.9896 6.80208 25.3438 7.15625C25.6979 7.51042 25.875 7.95833 25.875 8.5V21.5C25.875 22.0417 25.6979 22.4896 25.3438 22.8438C24.9896 23.1979 24.5417 23.375 24 23.375H6ZM6 22.5H24C24.25 22.5 24.4792 22.3958 24.6875 22.1875C24.8958 21.9792 25 21.75 25 21.5V8.5C25 8.25 24.8958 8.02083 24.6875 7.8125C24.4792 7.60417 24.25 7.5 24 7.5H6C5.75 7.5 5.52083 7.60417 5.3125 7.8125C5.10417 8.02083 5 8.25 5 8.5V21.5C5 21.75 5.10417 21.9792 5.3125 22.1875C5.52083 22.3958 5.75 22.5 6 22.5Z",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentsManagement);
export default __webpack_public_path__ + "static/media/payments-management.44606d78.svg";
export { ForwardRef as ReactComponent };